export default __webpack_public_path__ + "simple-map-800-fb194215f47d1d2d49459e6925cb8ae1.webp";